import { FormEventHandler, ReactNode } from "react";
import { Alert } from "@aws-amplify/ui-react";
import { UIBox } from "../../_core/components";
import UITypography from "../../_core/components/ui/UITypography";

interface AuthFormShellProps {
  heading: string;
  onSubmit: FormEventHandler<HTMLFormElement>;
  fields: ReactNode;
  actions: ReactNode;
  error?: string | null;
  onDismissError?: () => void;
}

/**
 * Shared layout for the auth forms: the `data-amplify-form` wrapper, centred heading, the fields,
 * a dismissible error alert below the inputs (Amplify look), then the actions.
 */
const AuthFormShell = ({ heading, onSubmit, fields, actions, error, onDismissError }: AuthFormShellProps) => (
  <form onSubmit={onSubmit} data-amplify-form style={{ padding: "24px 32px" }}>
    <UIBox component="div" display="flex" flexDirection="column" alignItems="stretch" gap="1rem" height="100%">
      <UITypography variant="h3" textAlign="center" className="amplify-heading">
        {heading}
      </UITypography>

      {fields}

      {Boolean(error) && (
        <Alert variation="error" hasIcon isDismissible onDismiss={onDismissError}>
          {error}
        </Alert>
      )}

      {actions}
    </UIBox>
  </form>
);

export default AuthFormShell;
